<template>
  <v-card class="pa-4 my-4">
    <div class="text-uppercase my-4 d-flex align-items-center ga-2">
      <p class="font-weight-medium">Vehicle Name Type</p>
      <v-tooltip
        text="Whether you want to display just the model name or make and model name"
        max-width="320px"
      >
        <template v-slot:activator="{ props }">
          <v-icon color="primary" v-bind="props">mdi-information</v-icon>
        </template>
      </v-tooltip>
    </div>
    <v-select
      v-model="vehicleNameType"
      :items="['Make Model', 'Model']"
      color="primary"
    ></v-select>
  </v-card>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useSettingsStore } from '@/stores/settings'

const props = defineProps<{
  selectedPlacement: string
}>()

const vehicleNameType = ref('Model')

const settingsStore = useSettingsStore()

onMounted(() => {
  vehicleNameType.value =
    settingsStore.placements.placements[props.selectedPlacement].vehicleNameType ?? 'Model'
})

watch(vehicleNameType, () => {
  settingsStore.placements.placements[props.selectedPlacement].vehicleNameType =
    vehicleNameType.value
})
</script>
